<template>
  <v-container justify-center xs12 sm6 lg4>
    <v-card>
      <v-card-title class="primary white--text headline">
        {{ $t('end_registration') }}
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <div class="pa-3 text-xs-center">
            <h2 class="display-1 font-weight-light mb-2">{{ info }}</h2>
          </div>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" flat to="/login">{{ $t('login') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'finish-registration',
  props: {
    registrationCode: null
  },
  data() {
    return {
      info: ''
    }
  },

  methods: {
    async finish() {
      this.$root.$loader(true)
      try {
        let res = await this.$http.get(
          this.$providerURL +
            `/Api/Partner/FinishRegistration?registrationCode=${
              this.registrationCode
            }`
        )
        if (res.status === 200) {
          this.info = this.$t('reg_ok')
          setTimeout(() => this.$router.push('/login'), 15000)
        }
      } catch (error) {
        this.info = this.$t('reg_fail')
      } finally {
        this.$root.$loader(false)
      }
    }
  },
  mounted() {
    this.finish()
  }
}
</script>
